import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setErrorMessages, getShowAllErrors } from '../../state/errorMessagesSlice';
import { useGetErrorMessagesAndTranslations } from '../../hooks/useGetErrorMessagesAndTranslations';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PostalCode({
  value,
  onChange,
  disabled,
  isShippingAddress = false
}) {
  const dispatch = useDispatch();
  const showAllErrors = useSelector(getShowAllErrors);
  const [hasBeenBlurred, setHasBeenBlurred] = useState(false);
  const isError = (hasBeenBlurred || showAllErrors) && !value;
  useEffect(() => {
    dispatch(setErrorMessages({
      [`empty${isShippingAddress ? 'Shipping' : 'Billing'}PostalCode`]: {
        isError
      }
    }));
  }, [isError, dispatch, isShippingAddress]);
  const errorMessage = useGetErrorMessagesAndTranslations().get('emptyPostalCode');
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.fullAddress.postalCode"
    }),
    required: true,
    "data-test-id": "postal-code-field",
    error: isError,
    validationMessage: isError && errorMessage,
    children: /*#__PURE__*/_jsx(TextInput, {
      value: value,
      onChange: onChange,
      disabled: disabled,
      "data-test-id": "postal-code-input",
      use: "on-dark",
      onBlur: () => setHasBeenBlurred(true)
    })
  });
}